import { render, staticRenderFns } from "./BotSettingNew.vue?vue&type=template&id=2a604f0c&scoped=true&"
import script from "./BotSettingNew.vue?vue&type=script&lang=js&"
export * from "./BotSettingNew.vue?vue&type=script&lang=js&"
import style0 from "./BotSettingNew.vue?vue&type=style&index=0&id=2a604f0c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a604f0c",
  null
  
)

export default component.exports